export default __webpack_public_path__ + "static/media/clouds.6eb66f7f.mp4";